import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './OriginalWork.css';

const OriginalWork = () => {
  const collections = [
    {
      id: 'black-white',
      name: 'Black and White Paintings',
      description: 'A study in contrast and form, exploring the depths of monochromatic expression.',
      image: '/bw1.jpg',
      link: '/collection/black-white'
    },
    {
      id: 'pink',
      name: 'Pink Collection',
      description: 'Vibrant pink artworks that capture emotion and energy with bold, expressive brushstrokes.',
      image: '/pink1.jpg',
      link: '/collection/pink'
    },
    {
      id: 'oil',
      name: 'Oil Collection',
      description: 'Rich oil paintings with deep textures and timeless beauty.',
      image: '/Oil1.jpg',
      link: '/collection/oil'
    },
    {
      id: 'mini',
      name: 'Mini Collection',
      description: 'Small-scale artworks perfect for intimate spaces, each piece carefully crafted with detail.',
      image: '/mini100.png',
      link: '/collection/mini'
    },
    {
      id: 'lowcountry',
      name: 'Low Country Summer Collection',
      description: 'Works inspired by the natural rhythms and vibrant colors of Charleston\'s coastal life.',
      image: '/LowCountry1.png',
      link: '/collection/lowcountry'
    }
  ];

  return (
    <div className="original-work">
      <motion.section
        className="gallery-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="gallery-hero-content">
          <motion.h1
            className="gallery-hero-title"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Original Works
          </motion.h1>
          <motion.p
            className="gallery-hero-subtitle"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Explore our curated collections
          </motion.p>
        </div>
      </motion.section>

      <section className="collections-preview-section">
        <div className="collections-preview-container">
          <motion.div
            className="collections-preview-grid"
            initial="hidden"
            animate="visible"
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.15
                }
              }
            }}
          >
            {collections.map((collection) => (
              <motion.div
                key={collection.id}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0 }
                }}
                transition={{ duration: 0.6 }}
              >
                <Link to={collection.link} className="collection-preview-card">
                  <div className="collection-preview-image">
                    <img src={collection.image} alt={collection.name} />
                    <div className="collection-preview-overlay">
                      <div className="collection-preview-content">
                        <h2 className="collection-preview-name">{collection.name}</h2>
                        <p className="collection-preview-description">{collection.description}</p>
                        <span className="collection-preview-button">
                          View Collection
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <motion.section
        className="inquiry-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="inquiry-content">
          <h2>Interested in a Piece?</h2>
          <p>Contact us to inquire about pricing, availability, or commission requests.</p>
          <Link to="/contact" className="inquiry-button">
            Make an Inquiry
          </Link>
        </div>
      </motion.section>
    </div>
  );
};

export default OriginalWork;
